import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class TerritoryMultiplierService {
    
    async getTerritoryMultiplierData(data) {
        const url = `${REP_API_URL}get-territory-multiplier-data`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }
}

export default TerritoryMultiplierService;
